import { FC, useState } from 'react'
import { Link } from 'react-router-dom'

import ChatBubble from '@/components/ChatBubble'
import { IMessage } from '@/context/types'

import { useCheckMobile } from '@/hooks/useCheckMobile'

import { DIRECTION, MAX_CHAT_BUBBLE_LINES } from '@/context/constants'
import { removeWhitespaces } from '../utils'

interface RedirectLinkProps {
  message: IMessage
}

const RedirectLink: FC<RedirectLinkProps> = ({ message }) => {
  const [open, setOpen] = useState(false)
  const isMobile = useCheckMobile()

  const displayMessage = (messageText: string) => {
    const showLess = !open
    const splitMessage = messageText.split('\n')

    let showMessage = messageText
    if (splitMessage.length > MAX_CHAT_BUBBLE_LINES && showLess) {
      showMessage = splitMessage.slice(0, MAX_CHAT_BUBBLE_LINES + 1).join('\n')
    }

    return (
      <>
        {removeWhitespaces(showMessage)}
        {splitMessage.length > MAX_CHAT_BUBBLE_LINES && (
          <div>
            {!open && <div className="pmui-text-base">...</div>}
            <div className="pmui-mt-3">
              <span
                className="pmui-cursor-pointer pmui-text-xs pmui-font-semibold pmui-underline"
                onClick={() => {
                  setOpen(prev => !prev)
                }}
              >
                {open ? 'Show less' : 'Show more'}
              </span>
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <>
      {message.content.text && (
        <div className="sm:pmui-text-xs md:pmui-text-sm">
          {message.content.text}
        </div>
      )}
      <ChatBubble direction={DIRECTION.LEFT}>
        <Link
          to={{
            pathname: message.metadata?.path,
            state: {
              chatWidgetOpen: isMobile ? false : true,
            },
          }}
        >
          <div
            className="sm:pmui-text-xs md:pmui-text-sm pmui-font-eina03 pmui-font-semibold 
        pmui-text-pop-orange pmui-underline pmui-whitespace-pre-wrap hover:pmui-cursor-pointer"
          >
            {displayMessage(message.content?.text)}
          </div>
        </Link>
      </ChatBubble>
    </>
  )
}

export default RedirectLink
